import { AuthentificationComponent } from './authentification/authentification.component';
import { AdminComponentComponent } from './admin-component/admin-component.component';
import { DashboardComponent } from './admin-component/dashboard/dashboard.component';
import { AddCompteServerComponent } from './admin-component/add-compte-server/add-compte-server.component';
import { CompteDetailsComponent } from './admin-component/compte-details/compte-details.component';
import { ComptesServerComponent } from './admin-component/comptes-server/comptes-server.component';
import { ErrorComponent } from './error/error.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArchiveComponent } from './admin-component/archive/archive.component';

/**
 * 
 *  created by AHMED HAYEL 
 *
 */

const routes: Routes = [{path: '',  redirectTo: 'authentification',  pathMatch: 'full'},
{path: 'authentification',  component: AuthentificationComponent},
/*{path: 'admin',  component: DashboardComponent,  children: [
    {path: '',      redirectTo: 'dashboard',      pathMatch: 'full'},
    {path: 'dashboard',      component: DashboardComponent},
    {path: 'compteDetails/:idCompteClientServer',      component: CompteDetailsComponent},
    {path: 'addServer',      component: AddCompteServerComponent},
    {path: 'listServer',     component: ComptesServerComponent}, 
    {path: 'archiveBoitier/:numBoitier',      component: ArchiveComponent}
  ]
},*/
{
        path: 'admin',
        loadChildren: 'app/admin-component/admin-component.module#AdminComponentModule'
      },
{
  path: '**',
  component: ErrorComponent
},
{
  path: 'error',
  component: ErrorComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModuleModule { }



// WEBPACK FOOTER //
// ./src/app/routing-module.module.ts